var render = function render(){var _vm=this,_c=_vm._self._c;return _c('centered-box',[_c('b-card',{staticClass:"title-center",attrs:{"title":"Sign out","border-variant":"primary"}},[_c('div',[_vm._v(" We're signing you out "),_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"20px"}},[_c('loading-spinner')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }